import React, { useState } from 'react';
import CompareGameFilter from '@/pages/dashboard/pages/benchmark/components/CompareGameFilter';
import CommonBubble from '@home/components/CommonBubble';
import './index.scss';
import FilterSelectButton from '@/pages/dashboard/components/FilterSelect/components/FilterSelectButton';

interface ICompetitorsSelector {
  value: Array<any>;
  onConfirm: (targetList: Array<any>) => void;
  maxSelected: number;
  showBubble?: boolean;
  bubbleContent?: string;
  name: string;
  palaceHolder: string;
  getData: (params:any, setCompetorLoading:()=>void, setFilterGames:()=>void, setGameList:()=>void, setCompetitorError:(error: any) => void)=> any;
  tip?: string;
};

const CompetitorsSelector = (props: ICompetitorsSelector) => {
  const {
    value,
    onConfirm,
    maxSelected = 5,
    showBubble = false,
    bubbleContent,
    name,
    getData,
    palaceHolder,
    tip
  } = props;
  const [visible, setVisible] = useState(false);

  const handleCofirm = (value: Array<any>) => {
    onConfirm?.(value);
  };

  return (
    <CommonBubble
      className={"dbd-benchmark-competitors-selctor-bubble"}
      content={showBubble ? bubbleContent : ''}
      overlayClassName='dbd-version-filter-bubble-box'
      visible={true}
      escapeWithReference
      flipped={false}
      destroyOnClose={false}
    >
      <div className="dbd-benchmark-competitors-selctor" onClick={() => setVisible(true)}>
        <FilterSelectButton
          name={name}
          selectedOptions={value}
          showSlectedNum={2}
          placeholder={palaceHolder}
        />
        <i className="tea-icon tea-icon-arrowdown dbd-benchmark-competitors-selctor-icon" role="img" aria-label="arrowdown"></i>
        {
          <CompareGameFilter
            visible={visible}
            // value={gameValues}
            getData={getData}
            value={value}
            maxSelected={maxSelected}
            onConfirm={handleCofirm}
            onClose={() => {
              setVisible(false);
            }}
            tip={tip}
          />
        }
      </div>
    </CommonBubble>

  );
};

export default CompetitorsSelector;
